import { ApiError, ApiErrorDetails } from './models/api-error.models';

/** Whether a rejection is the interceptor's normalised API error (anything thrown past the interceptor is). */
export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    typeof (error as ApiError).httpCode === 'number' &&
    typeof (error as ApiError).message === 'string'
  );
}

/** The server's own message, else the caller's fallback (a translated line). */
export function apiErrorMessage(error: unknown, fallback: string): string {
  return isApiError(error) && error.message && !error.defaultMessage
    ? error.message
    : fallback;
}

/** One typed entry of the error's details, undefined when the error carries none. */
export function apiErrorDetail<T>(
  error: unknown,
  key: keyof ApiErrorDetails | string,
): T | undefined {
  return isApiError(error) && error.details
    ? (error.details[key as string] as T | undefined)
    : undefined;
}
